import { ThreeDots } from "react-loader-spinner"
export default function Loader(){
    return (
        <ThreeDots color="#1C5DCC"/>
    )
}